var app = angular.module('navigation.frameNavTop');
app.directive('frameNavTop', ['$window', frameNavTop]);

function frameNavTop($window) {
    return {
        template: require('../templates/header.html'),
        controller: ['$rootScope', '$scope', '$state', '$document', 'Authentication', 'Bills', 'Pay', Ctrl],
        controllerAs: 'vm',
    };

    function Ctrl($rootScope, $scope, $state, $document, Authentication, Bills, Pay) {
        $scope.state = $state;
        $scope.preLoader = false;
        $scope.sliderFormPreLoader = false;
        $scope._sliderFormActive = '';
        $scope.isAuth = false;
        $scope.billsNum = 0;
        $scope.pay = Pay;

        $scope.toService = function() {            

            var data = {
                serviceId: $scope.pay.info.id,
                url: $scope.pay.info.id,
                fields: [],
                amount: 0,
                autoCheck: false
            };

            $scope.preLoader = true;
            $state.go('pages.service', data);
        };

        $scope.goTop = function () {

            if($state.current.name == 'pages.main') {
                $document.scrollTopAnimated(0);

            }
        };
    }

}

module.exports = app;


/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/frameHeader/directives/framenavtop.directive.js
 ** module id = 248
 ** module chunks = 1
 **/